<div class="content">
    <ion-icon [src]="icon"></ion-icon>
    <ion-label>{{message}}</ion-label>
</div>
